module.exports = __webpack_public_path__ + "img/98.de12fb92.jpg";